import { useEffect } from "react";
import { ShieldCheck } from "lucide-react";
import logoPng from "@/assets/brema-logo.png";

const SECTIONS = [
  {
    title: "Informativa GDPR 679/16",
    text: "Le informazioni contenute nelle comunicazioni inviate da Brema Bike e i relativi allegati possono essere riservate e sono destinate esclusivamente al destinatario. La diffusione, distribuzione e/o copiatura è proibita. Se avete ricevuto un messaggio per errore, vi preghiamo di distruggerlo e di informarci all'indirizzo sales2@brema-1969.com. Il titolare del trattamento è Above 59 Srl. I dati di contatto (nome, e-mail, telefono, azienda) sono trattati per finalità commerciali e di ufficio stampa; in qualsiasi momento è possibile richiedere l'accesso, la rettifica o la cancellazione dei dati scrivendo a sales2@brema-1969.com oppure usando il link \"Annulla iscrizione\" presente in ogni e-mail.",
  },
  {
    title: "Confidentiality & Privacy Notice",
    text: "The information contained in messages sent by Brema Bike is confidential and intended solely for the addressee. If you received an email in error, please delete it and notify sales2@brema-1969.com. The data controller is Above 59 Srl. Contact data (name, e-mail, phone, company) is processed for commercial and press-office purposes; you may request access, rectification or deletion at any time by writing to sales2@brema-1969.com or by using the \"Unsubscribe\" link included in every email. Please consider the environment before printing.",
  },
];

export default function PrivacyNotice() {
  useEffect(() => { document.title = "Brema 1969 · Privacy Notice"; }, []);
  return (
    <div className="min-h-screen bg-background px-5 py-14 text-foreground" data-testid="privacy-page">
      <div className="mx-auto w-full max-w-2xl rounded-2xl border border-border bg-card p-8 sm:p-10">
        <img src={logoPng} alt="Brema 1969" className="mb-8 h-9 w-auto dark:brightness-0 dark:invert" />
        <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-primary">
          <ShieldCheck className="h-3.5 w-3.5" /> Privacy
        </div>
        <h1 className="text-2xl font-bold sm:text-3xl" data-testid="privacy-title">Informativa privacy / Privacy Notice</h1>
        <div className="mt-8 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title} data-testid="privacy-section">
              <h2 className="text-base font-semibold md:text-lg">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.text}</p>
            </section>
          ))}
        </div>
        <p className="mt-10 text-xs text-muted-foreground">Above 59 Srl · <a href="mailto:sales2@brema-1969.com" className="text-primary underline">sales2@brema-1969.com</a> · <a href="https://www.brema-1969.com" className="text-primary underline" target="_blank" rel="noopener noreferrer">www.brema-1969.com</a></p>
      </div>
    </div>
  );
}
